var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbUp = function SvgThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7.31 6.6s-.35.85-1.1 1.43c-.76.58-1.61.57-1.61.57h-.4v7.6h9.07c.44 0 .98-.3 1.2-.69 0 0 .83-1.29 1.63-3.71.8-2.42.88-3.62.88-3.62a1.32 1.32 0 0 0-1.36-1.58H11.4l.8-4.4c0-.66-.54-1.2-1.2-1.2H9.8L7.31 6.6Z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 7.8h3.2v8.4H1z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgThumbUp;